import './routes';

// Extends and overrides API
import './views/FrontPageView';



// WEBPACK FOOTER //
// ./plugins/homepage/web_client/main.js